export const GENERATE_COUPON = "GENERATE_COUPON";
export const GENERATE_COUPON_SUCCESS = "GENERATE_COUPON_SUCCESS";
export const GENERATE_COUPON_ERROR = "GENERATE_COUPON_ERROR";

export const GET_COUPON_BUNDLE = "GET_COUPON_BUNDLE";
export const GET_COUPON_BUNDLE_SUCCESS = "GET_COUPON_BUNDLE_SUCCESS";
export const GET_COUPON_BUNDLE_ERROR = "GET_COUPON_BUNDLE_ERROR";

export const GET_COUPON_BY_BUNDLE = "GET_COUPON_BY_BUNDLE";
export const GET_COUPON_BY_BUNDLE_SUCCESS = "GET_COUPON_BY_BUNDLE_SUCCESS";
export const GET_COUPON_BY_BUNDLE_ERROR = "GET_COUPON_BY_BUNDLE_ERROR";

export const DELETE_BUNDLE = "DELETE_BUNDLE";
export const DELETE_BUNDLE_SUCCESS = "DELETE_BUNDLE_SUCCESS";
export const DELETE_BUNDLE_ERROR = "DELETE_BUNDLE_ERROR";

export const DELETE_COUPON = "DELETE_COUPON";
export const DELETE_COUPON_SUCCESS = "DELETE_COUPON_SUCCESS";
export const DELETE_COUPON_ERROR = "DELETE_COUPON_ERROR";

export const EDIT_BUNDLE = "EDIT_BUNDLE";
export const EDIT_BUNDLE_SUCCESS = "EDIT_BUNDLE_SUCCESS";
export const EDIT_BUNDLE_ERROR = "EDIT_BUNDLE_ERROR";

export const EDIT_COUPON = "EDIT_COUPON";
export const EDIT_COUPON_SUCCESS = "EDIT_COUPON_SUCCESS";
export const EDIT_COUPON_ERROR = "EDIT_COUPON_ERROR";

export const UPDATE_BUNDLE = "UPDATE_BUNDLE";
export const UPDATE_BUNDLE_SUCCESS = "UPDATE_BUNDLE_SUCCESS";
export const UPDATE_BUNDLE_ERROR = "UPDATE_BUNDLE_ERROR";

export const UPDATE_COUPON = "UPDATE_COUPON";
export const UPDATE_COUPON_SUCCESS = "UPDATE_COUPON_SUCCESS";
export const UPDATE_COUPON_ERROR = "UPDATE_COUPON_ERROR";

export const COUPON_RESEND_EMAIL = "COUPON_RESEND_EMAIL";
export const COUPON_RESEND_EMAIL_SUCCESS = "COUPON_RESEND_EMAIL_SUCCESS";
export const COUPON_RESEND_EMAIL_ERROR = "COUPON_RESEND_EMAIL_ERROR";